import React, { useEffect, useState } from "react";
import Storages from "../helper/storages";
import NewRequest from "./newRequest";
import loaderModal from "../modals/loaderModal";
import changePassword from "../modals/changePassword";
import useEndpoints from "../api/useEndpoints";
import axios from "axios";
import errorHandler from "../api/errorHandler";
import toast from "./toast";
import changeAddress from "../modals/changeAddress";
import AddOriginAddress from "../modals/addOriginAddress";
export default function Profile() {
    var endpoints = useEndpoints();
    var avatar = require(`../assets/images/${process.env.REACT_APP_ENV}/avatar.png`)

    var handleChangePassword = (e) => {
        changePassword.show(confirm => {
            if (confirm.newPass == confirm.newPassCheck) {
                axios.put(endpoints.password, confirm,
                    {
                        headers:
                        {
                            'x-auth-token': Storages.getUserToken()
                        }
                    }).then((res) => {
                        toast.Success("پسورد با موفقیت تغییر یافت")
                    }).catch((e) => {
                        errorHandler(e)
                    })

            } else {
                toast.Error("پسورد جدید با تکرارش مقدار یکسانی ندارد")
            }
            console.log(confirm)
        })
    }


    var [haveLocation, setHaveLocation] = useState(false);
    var handleChangeAddress = (e) => {
        console.log(haveLocation)
        setHaveLocation(true)

    }

    useEffect(() => {
        console.log('fffffffffff', haveLocation)

    }, [haveLocation])
    return (
        <div className=" position-fixed  fixedPage overflow-auto">


            <div className="container  mt-3  "  >

                <div className=" row  card bg-light rounded "  >
                    <div className="d-flex  mt-5 justify-content-center w-100 ">
                        <img src={avatar} style={{ width: "10rem" }} />
                    </div>

                    <div className="d-flex  mt-5 justify-content-center w-100 ">
                        <button className="btn-warning btn w-50 iranSansBold " onClick={handleChangePassword}>تغییر کلمه عبور</button>
                    </div>
                    <div className="d-flex  mt-5 justify-content-center w-100 ">
                        <button className="btn-warning btn w-50 iranSansBold " onClick={handleChangeAddress}>تغییر آدرس</button>
                    </div>

                    <div className="row mt-5 mb-5">

                        <div className="col-12 col-lg-6 ">
                            <InfoText title="کد اشتراک :" value={Storages.getUserInfo()?.eshterakId} />
                            <InfoText title="نام :" value={Storages.getUserInfo()?.name} />
                        </div>
                        <div className="col-12 col-lg-6 ">
                            <InfoText title="آدرس پیش فرض مبدا :" value={Storages.getUserInfo()?.address} />
                            <InfoText title="شماره همراه :" value={Storages.getUserInfo()?.mobile} />

                        </div>
                    </div>

                </div>

            </div>

            <AddOriginAddress
                onClose={() => {
                    setHaveLocation(false)
                }}
                eshCode={Storages.getUserInfo().eshterakId}

                show={haveLocation}
                onResult={(params) => {
                    setHaveLocation(false)

                    axios.put(endpoints.address, params,
                        {
                            headers:
                            {
                                'x-auth-token': Storages.getUserToken()
                            }
                        }).then((res) => {

                            Storages.setUserInfo({ ...Storages.getUserInfo(), ...params, address: params?.fullAddress })
                            toast.Success("آدرس با موفقیت تغییر یافت")
                        }).catch((e) => {
                            errorHandler(e)
                        })
                }
                } />
        </div>

    )
}


function InfoText(props) {
    return (
        <div >
            <h5 className="opacity-50">
                {props.title}
            </h5>
            <h4>
                {props.value}
            </h4>
            <hr className="" />
        </div>
    )
}